import { useEffect } from "react";

export function usePageMeta(title, description) {
  useEffect(() => {
    const baseTitle = "Vaana BuildLogic Technologies";
    document.title = title ? `${title} | ${baseTitle}` : `${baseTitle} | Enterprise IT, ERP & Cloud Solutions`;

    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute("content", description);

      let ogDesc = document.querySelector('meta[property="og:description"]');
      if (ogDesc) ogDesc.setAttribute("content", description);

      let twDesc = document.querySelector('meta[name="twitter:description"]');
      if (twDesc) twDesc.setAttribute("content", description);
    }

    if (title) {
      let ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) ogTitle.setAttribute("content", `${title} | ${baseTitle}`);

      let twTitle = document.querySelector('meta[name="twitter:title"]');
      if (twTitle) twTitle.setAttribute("content", `${title} | ${baseTitle}`);
    }
  }, [title, description]);
}
